import { render, staticRenderFns } from "./Role-filter.vue?vue&type=template&id=521a0454"
import script from "./Role-filter.vue?vue&type=script&lang=js"
export * from "./Role-filter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports